import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead';
import { getOptionLabel } from 'react-bootstrap-typeahead/es/utils';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import { g as getEnumOptions, p as processValue } from './index-ca2214b3.js';
import { isEmpty } from 'lodash';
import '@rjsf/core';
import 'react-bootstrap';
import 'classnames';
import 'react-number-format';
import 'dayjs';
import 'rc-picker';
import 'rc-picker/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import 'rc-picker/es/generate/dayjs';
import 'rc-picker/assets/index.css';
import 'styled-components';
import 'path';
import 'react-fast-compare';

function TypeaheadWidget(props) {
  const {
    id,
    schema,
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
    onBlur,
    onFocus,
    rawErrors = []
  } = props;
  const {
    onSearch,
    onChange,
    async = true,
    filter = false,
    minLength = 1,
    multiple = props.multiple,
    placeholder
  } = options;
  const enumOptions = getEnumOptions(props);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);
  const handleChange = useCallback(selected => {
    setSelected(selected);
    const newValue = selected.map(item => typeof item === 'string' ? item : item.value);
    const value = processValue(schema, multiple ? newValue : newValue[0]);
    props.onChange(value ?? schema.default);
    onChange?.(selected);
  }, [props.onChange]);
  const filterBy = useMemo(() => {
    if (!filter) {
      return () => true;
    }
    return undefined;
  }, [filter]);
  const typeaheadProps = {
    id,
    options: items,
    multiple,
    disabled: disabled || readonly,
    isInvalid: rawErrors.length > 0,
    clearButton: !required,
    autoFocus: autofocus,
    onBlur: () => {
      onBlur(id, value);
    },
    onFocus: () => {
      onFocus(id, value);
    },
    onChange: handleChange,
    placeholder: placeholder || '请选择',
    selected,
    filterBy,
    renderMenuItemChildren: (option, props) => getOptionLabel(option, props.labelKey)
  };
  if (onSearch) {
    useEffect(() => {
      if (!isEmpty(value) || minLength === 0 || !async) {
        setLoading(true);
        onSearch(async ? {
          value
        } : {}).then(function () {
          let result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          setItems(result || []);
          if (typeof value === 'number' || !isEmpty(value)) {
            if (multiple) {
              setSelected(result.filter(item => value.includes('value' in item ? item.value : item)));
            } else {
              setSelected(result.filter(item => ('value' in item ? item.value : item) == value));
            }
          } else if (result.length > 0 && !async && !multiple && schema.default === null) {
            //选择第一个
            handleChange([result[0]]);
          }
        }).finally(() => {
          setLoading(false);
        });
      }
    }, []);
    if (async) {
      const handleSearch = useCallback(async query => {
        try {
          setLoading(true);
          const result = await onSearch({
            query
          });
          setItems(result || []);
        } finally {
          setLoading(false);
        }
      }, []);
      return jsx(AsyncTypeahead, {
        ...typeaheadProps,
        isLoading: loading,
        minLength: minLength,
        onSearch: handleSearch
      });
    }
  }
  useEffect(() => {
    if (enumOptions.length > 0) {
      setItems(enumOptions);
      let selected = [];
      if (typeof value === 'number' || !isEmpty(value)) {
        selected = enumOptions.filter(item => {
          if (multiple) {
            return value.includes('value' in item ? item.value : item);
          }
          return ('value' in item ? item.value : item) == value;
        });
        setSelected(selected);
      }
      if (selected.length === 0 && enumOptions.length > 0 && !multiple && schema.default === undefined) {
        //选择第一个
        requestAnimationFrame(() => {
          handleChange([enumOptions[0]]);
        });
      }
    }
  }, [JSON.stringify(enumOptions)]);
  return jsx(Typeahead, {
    ...typeaheadProps
  });
}

export { TypeaheadWidget as default };
